import { ensureAncillaryContentSubtype } from "../../../../common/types/AncillaryContentType";
import { ContentSubtype } from "../../../../common/types/ContentSubtype";
import { ensureMovieContentSubtype } from "../../../../common/types/MovieContentSubtype";
import {
    getOnPremMovieDetailsHref,
    getOnPremTvSeriesDetailsHref,
    getOnPremAncillaryDetailsHref
} from "../../../AssetsRoutes";

export const resolveOnPremAssetHref = (contentType: ContentSubtype, newAssetId: string): string => {
    switch (contentType) {
        case ContentSubtype.Movie:
        case ContentSubtype.TvSingle:
        case ContentSubtype.FeatureDocumentary:
        case ContentSubtype.ShortFilm:
            ensureMovieContentSubtype(contentType);
            return getOnPremMovieDetailsHref(newAssetId, contentType);
        case ContentSubtype.TV:
            return getOnPremTvSeriesDetailsHref(newAssetId);
        case ContentSubtype.Advert:
        case ContentSubtype.Promo:
        case ContentSubtype.Safety:
        case ContentSubtype.IndentWarning:
        case ContentSubtype.ClientSpecific:
            ensureAncillaryContentSubtype(contentType);
            return getOnPremAncillaryDetailsHref(newAssetId, contentType);
        default:
            return "";
    }
};
